import { useSelector } from 'react-redux';

import { AsyncActionStatus } from '../actions/common.actionTypes';
import { getCurrentConversation } from '../reducers/aiAssistant.selectors';

// True while the AI Assistant is generating a reply in the current conversation.
const useIsGeneratingReply = (): boolean =>
	useSelector(getCurrentConversation)?.status === AsyncActionStatus.LOADING;

export default useIsGeneratingReply;
